import {
  AuthorizationStates,
  ModulesStates,
  VisibilityStates,
} from '@racemap/utilities/consts/events';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import type { Immutable } from 'immer';
import { useQuery } from 'src/lib/customHooks';
import { UAParser } from 'ua-parser-js';

export const checkLeaderboardActivationState = (
  event: Immutable<RacemapEvent> | null,
): {
  isArchived: boolean;
  isModuleActivated: boolean;
  isEventAuthorized: boolean;
} => {
  if (event == null) {
    return {
      isArchived: false,
      isModuleActivated: true,
      isEventAuthorized: true,
    };
  }

  const isArchived = event?.visibility === VisibilityStates.ARCHIVED;
  const isModuleActivated = event?.modules.timing.state === ModulesStates.ACTIVATED;
  const isEventAuthorized = event?.authorization !== AuthorizationStates.NONE;

  return { isArchived, isModuleActivated, isEventAuthorized };
};

const userAgent = new UAParser();

export const useLeaderboardEnvironmentInfo = (): { isEmbedded: boolean; isMobile: boolean } => {
  const query = useQuery();
  const isEmbedded = query.get('embed') === 'true';
  const isMobile = userAgent.getDevice().type === 'mobile';

  return { isEmbedded, isMobile };
};
